export enum ProductCategoryType {
	ACCESSORIES = 'ACCESSORIES',
	SERVICE = 'SERVICE',
	CHARGING_POINT = 'CHARGING_POINT',
}
